import React from 'react';
import * as S from './style';

export interface Props {
    contents: string;
    isActive?: boolean;
    onClick?: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
}

function BtnNext({ contents, isActive = false, onClick }: Props): React.ReactElement {
    return (
        <S.BtnNext
            backGroundColor={isActive ? 'blue_900' : 'gray_opacity_200'}
            color={isActive ? 'gray_opacity_50' : 'gray_opacity_300'}
            fontStyle={'body1_bold'}
            height={64}
            onClick={isActive ? onClick : () => {}}
        >
            {contents}
        </S.BtnNext>
    );
}

export default BtnNext;
